export interface ShareMetadata {
    original_contact_id?: number;
    from_company_id?: number;
    from_company_name?: string;
    to_company_id?: number;
    to_company_name?: string;
    anonymized?: boolean;
    created_at?: string; // ISO string (שווה ערך ל־shared_at)
  }
  export enum DataAccessTypeEnum {
    FULL = 0,
    VIEW_ONLY = 1,
    SHARED_IN = 2,
    SHARED_IN_ANON = 3,
    DEMO = 4,
    SHARED_OUT_DEMO_ANON = 5,
    SHARED_OUT = 6,
    SHARED_OUT_ANON = 7,
  }
  
  export interface SharedContactDTO {
    id?: number; // contact ID being shared
    company_id?: number;
    first_name: string;
    last_name: string;
    target_company_share_token: string;
    data_access_type: DataAccessTypeEnum;
    share_metadata?: string | ShareMetadata; // אם מגיע כ-JSON מחרוזתי
  }

  export interface ShareContactResponse {
    new_contact_id: number;
    shared_with_company_name: string;
  }